import CommonButton from 'common/components/entities/Button/button'
import { WebinarCallToActionInterface } from 'common/types/entities/WebinarCallToActionInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useDelay } from 'publisher/hooks/useDelay'
import { useWebinar } from 'publisher/store'
import webinarSelectors from 'publisher/store/webinar/webinarSelectors'
import React, { useEffect, useState } from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/publisher/shared/hooks/use-theme-color/use-selected-button-color'
import { addUrlSchemaToTheLink } from '../../../../common/utils/urlUtils'

export type WebinarCallToActionPropsType = {
  entity: WebinarCallToActionInterface
}

function WebinarCallToActionNew({ entity }: WebinarCallToActionPropsType) {
  const [isClient, setIsClient] = useState(false)
  const sessionDelayInSeconds = useWebinar(
    webinarSelectors.getSessionDelayInSeconds,
  )
  const isVisible = useDelay(
    (entity.delay ? +entity.delay : 0) + sessionDelayInSeconds,
  )

  const handleClick = () => {
    if (entity.url) {
      window.location.assign(addUrlSchemaToTheLink(entity.url))
    }
  }

  useEffect(() => {
    setIsClient(true)
  }, [])

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })

  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(entity.buttonType)

  return (
    isClient && (
      <StyleWrapper
        flex
        flexColumn
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
        appearance={entity.appearance}
      >
        {isVisible && (
          <CommonButton
            text={entity.text}
            border={calculatedBorder.desktop}
            mobileBorder={calculatedBorder.mobile}
            subText={entity.subText}
            padding={calculatedPadding.desktop}
            mobilePadding={calculatedPadding.mobile}
            alignSelf={entity.alignSelf}
            background={
              (entity.background ?? entity.backgroundColor) ||
              buttonBackgroundColor
            }
            mobileBackground={
              (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
              buttonBackgroundColor
            }
            attrId={entity.htmlAttrId}
            width={entity.width}
            mobileWidth={entity.mobileWidth}
            textColor={entity.textColor || buttonTextColor}
            subTextColor={entity.subTextColor}
            mobileTextColor={entity.mobileTextColor || buttonTextColor}
            mobileSubTextColor={entity.mobileSubTextColor}
            textFontSize={calculatedFontSize.desktop}
            mobileTextFontSize={calculatedFontSize.mobile}
            subTextFontSize={entity.subTextFontSize}
            mobileSubTextFontSize={entity.mobileSubTextFontSize}
            textFontFamily={calculatedFontFamily.desktop}
            textFontWeight={calculatedFontWeight.desktop}
            textFontStyle={calculatedFontStyle.desktop}
            subTextFontFamily={entity.subTextFontFamily}
            subTextFontWeight={entity.subTextFontWeight}
            subTextFontStyle={entity.subTextFontStyle}
            mobileTextFontFamily={calculatedFontFamily.mobile}
            mobileTextFontWeight={calculatedFontWeight.mobile}
            mobileTextFontStyle={calculatedFontStyle.mobile}
            mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
            mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
            mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
            boxShadow={entity.boxShadow}
            mobileBoxShadow={entity.mobileBoxShadow}
            lineHeight={calculatedLineHeight.desktop}
            mobileLineHeight={calculatedLineHeight.mobile}
            iconClassNameBefore={entity.iconClassNameBefore}
            iconClassNameAfter={entity.iconClassNameAfter}
            onClick={handleClick}
            hover={{
              ...entity.hover,
              backgroundColor:
                entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
            }}
            mobileHover={{
              ...entity.mobileHover,
              backgroundColor:
                entity?.mobileHover?.backgroundColor ||
                entity?.hover?.backgroundColor ||
                hoveredButtonBackgroundColor,
            }}
          />
        )}
      </StyleWrapper>
    )
  )
}

export default WebinarCallToActionNew
